export type CaseStudy = {
  id: string;
  number: string;
  title: string;
  sector: string;
  organization: string;
  summary: string;
  problem: string;
  scope: string[];
  approach: string[];
  outputs: string[];
  decisions: string[];
  result: string;
  capabilities: string[];
  featured?: boolean;
};

export const caseStudies: CaseStudy[] = [
  {
    id: "multi-business-holding-strategy",
    number: "۰۱",
    title: "تدوین برنامه جامع استراتژیک برای یک هلدینگ چندکسب‌وکاره",
    sector: "هلدینگ و مدیریت پرتفوی",
    organization: "یک هلدینگ خصوصی با سبدی از کسب‌وکارهای صنعتی، معدنی، انرژی، کشاورزی و خدماتی",
    summary: "از تحلیل محیط و پرتفوی تا طراحی منطق حاکمیت، اولویت‌های رشد و نظام پایش اجرا",
    problem: "تنوع کسب‌وکارها بدون یک منطق یکپارچه برای نقش ستاد، تخصیص سرمایه، هم‌افزایی میان شرکت‌ها و تبدیل جهت‌گیری‌های کلان به برنامه قابل پیگیری، تصمیم‌گیری در سطح گروه را دشوار کرده بود.",
    scope: [
      "تحلیل محیط کلان و روندهای اثرگذار بر صنایع سبد",
      "بررسی منابع، قابلیت‌ها، ساختار و ترکیب پرتفوی گروه",
      "تعریف مأموریت، چشم‌انداز، ارزش‌ها و جهت‌گیری‌های کلان",
      "طراحی نقش ستاد، منطق حاکمیت و ارتباط با شرکت‌های تابعه",
      "بررسی سازوکارهای هم‌افزایی، سرمایه‌گذاری و تحول دیجیتال",
      "تبدیل اولویت‌ها به ابتکار، برنامه اقدام و منطق پایش",
    ],
    approach: [
      "تحلیل PESTEL و محیط داخلی",
      "تحلیل SWOT و ارزیابی توازن پرتفوی",
      "بررسی مزیت سرپرستی و سازوکارهای خلق ارزش ستاد",
      "طراحی سیاست‌های سرمایه‌گذاری و اولویت‌بندی پروژه‌ها",
      "تعریف برنامه‌های اقدام، نقاط عطف و شاخص‌های کلیدی",
    ],
    outputs: [
      "سند جامع استراتژی شرکتی و پرتفوی",
      "چارچوب مأموریت، چشم‌انداز و اهداف راهبردی",
      "منطق پیشنهادی حاکمیت و تقسیم نقش ستاد و واحدهای عملیاتی",
      "چارچوب ارزیابی و اولویت‌بندی سرمایه‌گذاری‌ها",
      "نقشه راه اجرا، ابتکارات، برنامه‌های اقدام و نظام KPI",
      "پیشنهادهای تحول دیجیتال، نوآوری و هم‌افزایی بین‌شرکتی",
    ],
    decisions: [
      "تمرکز ستاد بر هدایت راهبردی و واگذاری اختیار عملیات روزمره به کسب‌وکارها",
      "بازبینی دوره‌ای ترکیب پرتفوی و تخصیص منابع بر اساس تناسب راهبردی و ریسک",
      "ایجاد سازوکار رسمی برای ارزیابی سرمایه‌گذاری‌ها و پروژه‌های توسعه‌ای",
      "پایش ابتکارات با مسئول مشخص، زمان‌بندی، نقطه عطف و شاخص نتیجه",
    ],
    result: "چارچوب جامع جهت‌گیری گروه، مدیریت پرتفوی، حاکمیت و پایش اجرا تدوین شد؛ همراه با نقشه راه، ابتکارات و منطق شاخص‌های کلیدی.",
    capabilities: ["استراتژی شرکتی", "مدیریت پرتفوی", "حاکمیت", "سرمایه‌گذاری", "KPI و پایش", "تحول دیجیتال"],
    featured: true,
  },
  {
    id: "mining-company-strategy",
    number: "۰۲",
    title: "تدوین استراتژی برای یک شرکت معدنی اکتشاف‌محور",
    sector: "معدن و اکتشاف",
    organization: "یک شرکت معدنی در حال توسعه با سبدی از پروژه‌های اکتشافی و قابلیت‌های فنی در حال شکل‌گیری",
    summary: "تحلیل صنعت و قابلیت‌ها، انتخاب گزینه‌های راهبردی و طراحی منطق اولویت‌بندی پروژه‌ها",
    problem: "شرکت باید در محیطی سرمایه‌بر و پرریسک، میان پروژه‌های اکتشافی، توسعه قابلیت فنی، تأمین سرمایه و مسیر ورود به بهره‌برداری انتخاب‌های منسجم‌تری انجام می‌داد.",
    scope: [
      "تحلیل محیط سیاسی، اقتصادی، اجتماعی، فناوری، زیست‌محیطی و حقوقی",
      "بررسی ساختار رقابت و نیروهای اثرگذار در صنعت",
      "ارزیابی منابع، تیم، دارایی‌های اکتشافی و قابلیت‌های فناورانه",
      "تحلیل زنجیره ارزش از اکتشاف تا فرآوری و عرضه",
      "شناسایی قوت‌ها، ضعف‌ها، فرصت‌ها و تهدیدها",
      "طراحی گزینه‌های راهبردی و منطق اولویت‌بندی سبد پروژه‌ها",
    ],
    approach: [
      "PESTEL",
      "مدل پنج نیروی پورتر",
      "تحلیل VRIO",
      "زنجیره ارزش پورتر",
      "SWOT و راهبردهای SO، ST، WO و WT",
    ],
    outputs: [
      "گزارش جامع تحلیل محیط و صنعت",
      "ارزیابی منابع و قابلیت‌های مزیت‌ساز",
      "تصویر زنجیره ارزش و گلوگاه‌های گذار از اکتشاف به بهره‌برداری",
      "مجموعه گزینه‌های راهبردی تهاجمی، محافظتی و تدافعی",
      "منطق پیشنهادی برای اولویت‌بندی پروژه‌های اکتشافی",
      "چارچوب شاخص‌های فعالیت و پایش حوزه‌های کلیدی",
    ],
    decisions: [
      "تمرکز منابع بر پروژه‌های امیدبخش‌تر و پرهیز از پراکنده‌کاری",
      "توسعه تدریجی فناوری و همکاری علمی به‌عنوان قابلیت رقابتی",
      "بررسی مشارکت برای جبران شکاف سرمایه و تجربه بهره‌برداری",
      "طراحی سناریوهای مالی، خروج یا ادغام برای شرایط عدم‌قطعیت",
    ],
    result: "تحلیل‌های محیط، صنعت، قابلیت‌ها و زنجیره ارزش به گزینه‌های راهبردی، منطق اولویت‌بندی سبد پروژه‌ها و چارچوب پایش تبدیل شد.",
    capabilities: ["استراتژی کسب‌وکار", "تحلیل صنعت", "مدیریت سبد پروژه", "فناوری معدن", "مدیریت ریسک", "برنامه اجرایی"],
    featured: true,
  },
  {
    id: "business-continuity-framework",
    number: "۰۳",
    title: "طراحی چارچوب مدیریت بحران و تداوم کسب‌وکار",
    sector: "ریسک، بحران و تاب‌آوری",
    organization: "یک نهاد اقتصادی منطقه‌ای با شبکه‌ای متنوع از بنگاه‌ها و صنایع عضو",
    summary: "از تحلیل ریسک و فرایندهای حیاتی تا سناریوهای پاسخ، BCP، BCM و برنامه بازیابی",
    problem: "برای بحران‌های فراگیر، لازم بود یک زبان مشترک و سازوکار هماهنگ میان نهاد راهبر و بنگاه‌های عضو شکل بگیرد تا فعالیت‌های حیاتی، ارتباطات و مسیر بازیابی از پیش روشن باشند.",
    scope: [
      "شناسایی و اولویت‌بندی ریسک‌های عملیاتی، ارتباطی، سایبری و زنجیره تأمین",
      "تحلیل اثر وقفه بر کسب‌وکار و شناسایی فرایندهای حیاتی",
      "طراحی سناریوهای پاسخ و راهکارهای عملیاتی جایگزین",
      "برنامه ارتباطات بحران و تداوم فناوری اطلاعات",
      "طراحی توالی واکنش فوری، تثبیت و بازیابی",
      "پیشنهاد ساختار سازمانی، آموزش، مانور و بازنگری دوره‌ای",
    ],
    approach: [
      "ارزیابی ریسک و تحلیل اثر بر کسب‌وکار BIA",
      "شناسایی عملیات حیاتی و زمان بازیابی مورد انتظار RTO",
      "سناریونویسی و طراحی برنامه تداوم کسب‌وکار BCP",
      "طراحی چارچوب مدیریت تداوم کسب‌وکار BCM",
      "برنامه بازیابی پس از بحران و مرور درس‌آموخته‌ها",
    ],
    outputs: [
      "پروتکل جامع مدیریت بحران اقتصادی",
      "ماتریس ریسک، شدت اثر و اقدامات کاهش آسیب",
      "فهرست فرایندهای حیاتی و تدابیر تداوم هر یک",
      "سناریوهای بحران و طرح‌های عملیاتی جایگزین",
      "جدول زمانی واکنش و بازیابی از ساعات نخست تا ماه‌های بعد",
      "پیشنهاد ایجاد واحد تخصصی بحران، مرکز مشاوره و نظام آموزش و مانور",
    ],
    decisions: [
      "تدوین الگوی بومی BCP برای بنگاه‌های عضو",
      "تعیین مسئول، کانال جایگزین و سخنگوی ارتباطات بحران",
      "آزمون دوره‌ای زیرساخت‌های پشتیبان و اجرای مانورهای منظم",
      "بازنگری برنامه پس از هر رخداد یا تمرین و ثبت درس‌آموخته‌ها",
    ],
    result: "پروتکل، جداول ریسک، سناریوهای پاسخ و نقشه بازیابی تهیه شد و مدل پیشنهادی نهادینه‌سازی BCP و BCM تدوین شد.",
    capabilities: ["مدیریت ریسک", "BIA", "BCP", "BCM", "مدیریت بحران", "بازیابی عملیات"],
    featured: true,
  },
  {
    id: "construction-strategic-analysis",
    number: "۰۴",
    title: "تحلیل استراتژیک یک کسب‌وکار ساختمانی",
    sector: "ساخت‌وساز و توسعه شهری",
    organization: "یک شرکت عمرانی منطقه‌ای فعال در پروژه‌های ساختمانی و توسعه‌ای",
    summary: "بررسی بازار، صنعت و قابلیت‌های داخلی برای انتخاب موقعیت رقابتی و گزینه‌های رشد",
    problem: "نوسان هزینه‌ها، رقابت شدید، تغییر انتظارات بازار و وابستگی پروژه‌ها به تأمین مالی، انتخاب حوزه‌های رشد و مزیت قابل اتکا را پیچیده کرده بود.",
    scope: [
      "تحلیل محیط کلان و روندهای بازار ساخت‌وساز",
      "بررسی فشارهای رقابتی، تأمین‌کنندگان و قدرت خریداران",
      "ارزیابی منابع، تجربه اجرایی و توان زنجیره تأمین",
      "تحلیل زنجیره ارزش از طراحی و تأمین تا ساخت و فروش",
      "صورت‌بندی SWOT و گزینه‌های رشد برای افق میان‌مدت",
    ],
    approach: [
      "PESTEL",
      "مدل پنج نیروی پورتر",
      "تحلیل VRIO",
      "تحلیل زنجیره ارزش",
      "SWOT و طراحی راهبردهای تطبیقی",
    ],
    outputs: [
      "گزارش تحلیل محیط، بازار و صنعت",
      "ارزیابی قابلیت‌ها و منابع مزیت‌ساز",
      "نقشه قوت‌ها، ضعف‌ها، فرصت‌ها و تهدیدها",
      "گزینه‌های پیشنهادی برای رشد، تنوع پروژه و موقعیت رقابتی",
      "چشم‌انداز تحولات بازار و فناوری ساخت در افق میان‌مدت",
    ],
    decisions: [
      "تمرکز بر حوزه‌هایی که تجربه اجرایی و زنجیره تأمین در آن‌ها مزیت می‌سازد",
      "بررسی تنوع‌بخشی کنترل‌شده به نوع پروژه‌ها",
      "استفاده از مشارکت برای کاهش فشار تأمین مالی",
      "سرمایه‌گذاری هدفمند در فناوری و کیفیت ساخت برای تمایز",
    ],
    result: "تحلیل ساختاریافته محیط، صنعت و قابلیت‌های شرکت تهیه و گزینه‌های راهبردی تطبیقی برای افق تصمیم میان‌مدت پیشنهاد شد.",
    capabilities: ["تحلیل بازار", "استراتژی رقابتی", "VRIO", "زنجیره ارزش", "گزینه‌های رشد", "مدیریت ریسک"],
  },
  {
    id: "investment-opportunity-study",
    number: "۰۵",
    title: "مطالعه فرصت‌های سرمایه‌گذاری در یک زنجیره معدنی",
    sector: "مطالعات فرصت و سرمایه‌گذاری",
    organization: "مطالعه یک زنجیره زغال‌سنگ در یکی از استان‌های شمال‌غرب کشور",
    summary: "از ساختار ذخایر و زنجیره ارزش تا بازار، زیرساخت، ریسک و مدل‌های ورود سرمایه‌گذار",
    problem: "فرصت‌های پراکنده در استخراج، فرآوری و بازار بدون یک تصویر یکپارچه از کیفیت ذخایر، زیرساخت، تقاضا، ریسک و مدل مشارکت، برای تصمیم سرمایه‌گذاری کافی نبودند.",
    scope: [
      "مرور پراکندگی ذخایر و وضعیت توسعه محدوده‌ها",
      "بررسی فرصت‌های اکتشاف، استخراج، احیای معادن و تجمیع زیرساخت",
      "تحلیل فرصت‌های فرآوری و افزایش ارزش افزوده",
      "بررسی حمل‌ونقل، بازارهای داخلی و مسیرهای صادراتی",
      "مطالعه مدل‌های مشارکت خصوصی، عمومی و سرمایه‌گذار خارجی",
      "شناسایی ریسک‌های فنی، ایمنی، زیرساختی، قانونی و بازار",
    ],
    approach: [
      "تحلیل ساختار صنعت و زنجیره ارزش",
      "تفکیک فرصت‌ها بر اساس مرحله ایجاد ارزش",
      "مرور بازار مصرف و مزیت‌های لجستیکی",
      "تحلیل مدل‌های کنسرسیوم، مشارکت و سرمایه‌گذاری مشترک",
      "غربال اولیه ریسک‌ها و پیش‌نیازهای اجرایی",
    ],
    outputs: [
      "نقشه فرصت‌های سرمایه‌گذاری از اکتشاف تا بازار",
      "گزینه‌های فرآوری شامل زغال‌شویی و محصولات با ارزش افزوده بیشتر",
      "تحلیل اولیه بازارهای داخلی و منطقه‌ای",
      "مدل‌های پیشنهادی برای تجمیع معادن و زیرساخت مشترک",
      "گزینه‌های مشارکت و ورود سرمایه‌گذار",
      "فهرست موانع اجرایی و اقدامات پیش‌نیاز",
    ],
    decisions: [
      "انجام اکتشاف تکمیلی و آزمون کیفیت پیش از تعهد سرمایه‌ای سنگین",
      "بررسی تجمیع چند محدوده برای توجیه زیرساخت و واحد فرآوری مشترک",
      "اتصال تصمیم استخراج به کیفیت محصول، بازار هدف و هزینه لجستیک",
      "انتخاب مدل مشارکت متناسب با شکاف سرمایه، فناوری و دسترسی به بازار",
    ],
    result: "تصویری یکپارچه از فرصت‌های زنجیره، مدل‌های ورود و ریسک‌های کلیدی تهیه شد و فرصت‌ها در سطح شناسایی و غربال اولیه اولویت‌بندی شدند.",
    capabilities: ["مطالعات فرصت", "تحلیل صنعت", "زنجیره ارزش", "تحلیل بازار", "مدل مشارکت", "غربال ریسک"],
  },
];

export const featuredCaseStudies = caseStudies.filter((caseStudy) => caseStudy.featured);
